/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const cancelRoutineOverrideBodyExpectedVersionExclusiveMin = 0;
export const cancelRoutineOverrideBodyExpectedVersionMax = 9007199254740991;

export const CancelRoutineOverrideBody = zod.object({
  expectedVersion: zod
    .int()
    .gt(cancelRoutineOverrideBodyExpectedVersionExclusiveMin)
    .max(cancelRoutineOverrideBodyExpectedVersionMax),
});

export type CancelRoutineOverrideBody = zod.input<typeof CancelRoutineOverrideBody>;
export type CancelRoutineOverrideBodyOutput = zod.output<typeof CancelRoutineOverrideBody>;
